import { render, staticRenderFns } from "./Declaration_lb.vue?vue&type=template&id=c731c6e2&scoped=true"
import script from "./Declaration_lb.vue?vue&type=script&lang=js"
export * from "./Declaration_lb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c731c6e2",
  null
  
)

export default component.exports